import { useDispatch, useSelector } from 'react-redux';
import { useMe as useSharedMe } from '@make-software/tg-mini-app-ui';

import {
  AppDispatch,
  completeOnboarding as completeOnboardingActionCreator,
  fetchUser,
  selectUser,
  selectUserError,
  selectUserLoading
} from '@/shared';

export const useMe = (defaultLoading = true) => {
  const dispatch = useDispatch<AppDispatch>();
  const me = useSelector(selectUser);
  const loading = useSelector(selectUserLoading);
  const error = useSelector(selectUserError);

  const meService = useSharedMe({
    data: me,
    loading,
    error,
    defaultLoading,
    requireAuthKey: 'auth_provider',
    onFetchUser: (params) =>
      dispatch(
        fetchUser({
          withBalances: Boolean(params?.withBalances),
          ...(params?.captchaToken ? { captchaToken: params.captchaToken } : {})
        })
      ),
    onCompleteOnboarding: () => dispatch(completeOnboardingActionCreator())
  });

  const clearInitDataFromUrl = () => {
    const url = new URL(window.location.href);
    url.search = '';
    window.history.replaceState({}, document.title, `${url.pathname}${url.hash}`);
  };



  return {
    ...meService,
    clearInitDataFromUrl,
    userPointBalance: meService.balanceByUnit['points'] ?? 0,
    userRound1PointBalance: meService.balanceByUnit['round1'] ?? 0,
    userRound2PointBalance: meService.balanceByUnit['round2'] ?? 0
  };
};
